import InnerComponent from '@Components/Purchase/AccountPayableInvoice/AccountPayableInvoiceList';
import orgContainer from '@Components/AppContainer';

const AccountPayableInvoiceList = () => ((orgContainer(InnerComponent)));
export default AccountPayableInvoiceList;
